import { KollectionType } from '@cyberkongz/api-interfaces';
import { StringTraitsWithCountType } from '@cyberkongz/ui';

import KOLLECTIONS_STRING_TRAITS_WITH_COUNT_JSON from './kollectionsStringTraits.json';

// @ts-ignore
export const KOLLECTIONS_STRING_TRAITS: { [key in KollectionType]: StringTraitsWithCountType[] } =
  KOLLECTIONS_STRING_TRAITS_WITH_COUNT_JSON;
